/**
 * @fileoverview Centralized constants for deals functionality
 *
 * This file consolidates all deals-related UI and business logic constants.
 * Action types are kept separate in the Redux module.
 */

export default {
	// Deals Page
	DEALS_LANDING_PAGE_FETCHED: 'DEALS_LANDING_PAGE_FETCHED',
	DEAL_LOADED: 'DEAL_LOADED',
	LAYOUT_MAX_WIDTH: 1296,

	// Deal Types
	ALL_DEAL_TYPES: ['exclusive', 'gift', 'offer', 'custom'] as const,

	// Vendors Grid
	MAX_RESULT_COLUMNS: 4,
	MAX_RESULTS_PER_PAGE: 4 * 3, // max columns * max rows

	// RFQ Modal
	DEAL_CTA_TEXT: 'Claim Deal',
	DEAL_RFQ_HEADER_TEXT: 'Claim Deal',
	DEAL_RFQ_BUTTON_TEXT: 'Send',

	// Banner
	BANNER_IMG_ID_DESKTOP: 'fc396c64-0797-4ca0-9554-86fdf5348a09',
	BANNER_IMG_ID_MOBILE: '325b3968-857b-47df-b411-6ac289132348',
	BANNER_BF_IMG_ID: 'cb31787e-8e91-4c84-9893-2432b102f497',

	// Category Filter
	DEFAULT_CATEGORY_IMAGE: 'f164766f-3e00-4eb5-ae4b-997eabbf3a43',
	CATEGORY_SKELETON_KEYS: ['sk1', 'sk2', 'sk3', 'sk4', 'sk5', 'sk6'],
	CATEGORY_IMAGE_WIDTH: 112,
	CATEGORY_IMAGE_HEIGHT: 128,
	CATEGORY_SLIDE_WIDTH: 125,
	CATEGORY_SLIDE_GUTTER: 10,
	CATEGORY_SLIDE_MARGIN: 16,

	// Location
	DEFAULT_LOCATION: { city: 'Eastport', stateCode: 'ME' },

	// Drag & Scroll
	PIXEL_MOVE_LIMIT_FOR_DRAG: 3,
} as const;
